@if (loading$ | async) {
<div class="loading-overlay">
  <div class="spinner"></div>
</div>
}

<router-outlet />
